import { Box, Button, Container, makeStyles, Typography } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import React from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { startAlerta } from '../../../actions/ui/alertas';
import { finishSpinner, startSpinner } from '../../../actions/ui/spinner';
import { useForm } from '../../../hooks/useForm';
import AfiliadoService from '../../../services/AfiliadoService'
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es"; // without this line it didn't work

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  submit: {
    marginTop: "1rem",
    textTransform: "none"
  },
  title: {
    fontWeight: "bold"
  }
}));

const SelectDateScreen = (props) => {
  const { history } = props
  const classes = useStyles()
  const dispatch = useDispatch()
  const {nroDocumento} = useParams();

  const initialState = {
    fecha: moment(0).format('YYYY-MM-DD'),
  };

  // eslint-disable-next-line
  const [formValues, handleInputChange, reset, setearValor] = useForm(initialState);
  const { fecha} = formValues;

  const handleSelectDate = async (e) => {
    e.preventDefault();
        try {
            dispatch(startSpinner())
            const result=await AfiliadoService.selectDate(nroDocumento, moment(fecha).format('YYYY-MM-DD'))
            const body=await result.json()
            if(result.ok){
                dispatch(finishSpinner())
                dispatch(startAlerta("Fecha de nacimiento validada", "success"))
                history.push(`/afiliado/registro-sin-email/${nroDocumento}/${moment(fecha).format('YYYY-MM-DD')}`)
            }else{
                throw body.errores
            }
        } catch (error) {
            dispatch(finishSpinner())
            if(error.mensaje){
                dispatch(startAlerta(error.mensaje, "error"))
            }else{
                dispatch(startAlerta("Ha ocurrido un error al validar su fecha de nacimiento. Intente nuevamente.", "error"))
            }
            console.log("Error al validar la fecha de nacimiento del usuario", error)
        }
};

  return (
    <div className={classes.root}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <ValidatorForm onSubmit={handleSelectDate}>
            <Box p="1rem">
              <Typography align="center" variant="h4" className={classes.title} color="secondary">Validación de identidad</Typography>
              <Typography variant="body2" align="justify" style={{marginTop:"1rem"}}>Para continuar con el registro, te pedimos que, por favor, nos indiques tu fecha de nacimiento.</Typography>

              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  fullWidth
                  margin="normal"
                  id="dialogFecha_nacimiento"
                  label="Fecha de nacimiento"
                  format="dd/MM/yyyy"
                  okLabel="Aceptar"
                  required={true}
                  maxDate={new Date()} //maxDate
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  value={moment(fecha).isValid() ? moment(fecha) : 0}
                  onChange={(date) => {
                    setearValor('fecha', date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>

              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
              >
                Siguiente
              </Button>
              <Button
                component={Link}
                type="button"
                fullWidth
                variant="outlined"
                color="primary"
                className={classes.submit}
                to="/afiliado/registro"
              >
                Anterior
              </Button>

            </Box>
          </ValidatorForm>
        </Container>
      </Box>
    </div>
  )
}

export default SelectDateScreen
